"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.helpers = exports.isStatusRestricted = exports.getQAFailedReasons = exports.findEnquiryStateSlugsForCategory = void 0;
const enquiryStates_1 = require("./enquiryStates");
const restrictedStatuses_1 = require("./restrictedStatuses");
const qaFailedReasons = [];
for (const reason of enquiryStates_1.enquiryStates[enquiryStates_1.SLUGS.QA_FAILED].reasons) {
    for (const option of reason.options) {
        qaFailedReasons.push(option.id);
    }
}
const findEnquiryStateSlugsForCategory = (category) => Object.entries(enquiryStates_1.enquiryStates)
    .filter(([, value]) => value.category === category)
    .map(([slug]) => slug);
exports.findEnquiryStateSlugsForCategory = findEnquiryStateSlugsForCategory;
const getQAFailedReasons = () => qaFailedReasons;
exports.getQAFailedReasons = getQAFailedReasons;
const isStatusRestricted = (slug) => restrictedStatuses_1.RESTRICTED_STATUSES.includes(slug);
exports.isStatusRestricted = isStatusRestricted;
exports.helpers = {
    findEnquiryStateSlugsForCategory: exports.findEnquiryStateSlugsForCategory,
    getQAFailedReasons: exports.getQAFailedReasons,
    isStatusRestricted: exports.isStatusRestricted,
};
//# sourceMappingURL=helpers.js.map